import { object, string } from 'yup';
import { useTranslation } from '../../../../../../../i18n/use-translation';

export function getCompleteResetValidation() {
  const { t } = useTranslation();

  return object().shape({
    code: string().length(6, t('error.code_length')).required(t('requiredField')),
    password: string().min(3, t('error.pass_length_min')).required(t('requiredField')),
    passwordConfirm: string()
      .test('is-the-same-pass', t('error.pass_confirm'), (value: any, context: any) => {
        console.log(value, context)
        return value === context.parent.password;
      })
      .required(t('requiredField')),
  });
}
